<template>
<div class="account-card-wrapper">
  <div class="account-card d-flex flex-column text-center align-items-center justify-content-between">
    <div class="d-flex flex-column mt-4">
      <span class="is-bold mb-2">
        {{account.name}}
      </span>
      <span class="smaller-account-info">
        {{account.email}}
      </span>
      <span class="smaller-account-info">
        {{$t('accounts.registered')}} {{account.created_at | readableDate}}
      </span>
    </div>

    <div v-if="lastPermissionRequest" class="d-flex flex-column">
      <span class="is-bold" v-if="lastPermissionRequest.status === 1">
        {{$t('accounts.access_requested_at')}}
      </span>
      <span v-else-if="lastPermissionRequest.status === 2">
        {{$t('accounts.access_approved_at')}}
      </span>
      <span v-else>
        {{$t('acconts.access_revoked_at')}}
      </span>
      <span>
        {{moment(lastPermissionRequest.updated_at).format('YYYY-MM-DD')}}
      </span>
    </div>
    <div v-else>
      <va-button
        id="button-request-access"
        :disabled="isRequestingPermission"
        @click="requestAccess"
      >
        {{$t('accounts.request_access')}}
      </va-button>
    </div>
  </div>
</div>

</template>

<script>
import { AccountPermissionsService } from '@/api/ClinicalService'
import CurrentLocaleMixin from '@/mixins/CurrentLocaleMixin'
export default {
  props: {
    account: {
      type: Object,
      required: true
    },
    accountPermissions: {
      type: Array,
      required: true
    }
  },
  mixins: [
    CurrentLocaleMixin
  ],
  computed: {
    lastPermissionRequest: function () {
      return this.accountPermissions[this.accountPermissions.length - 1]
    }
  },
  data: function () {
    return {
      isRequestingPermission: false
    }
  },
  methods: {
    requestAccess: function () {
      this.isRequestingPermission = true
      AccountPermissionsService
        .store(this.$auth.user().entity.id, {
          account_id: this.account.id
        })
        .then(response => {
          this.$emit('new-permission', { ...response.data.data })
          this.showToast(this.$t('accounts.access_requested_success'), this.$store.state.successToastOptions)
        })
        .catch(errors => {
          this.showToast(this.$t('accounts.access_requested_failed', this.$store.state.errorToastOptions))
        })
        .finally(() => {
          this.isRequestingPermission = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
  .account-card-wrapper {
    padding: 0rem 1rem;
  }

  .account-card {
    cursor: pointer;
    padding: 1rem;
    min-height: 12rem;
    margin-bottom: 1rem;
    color: #6e6e6e;
    background-color: #f5f5f5;
    border-radius: 0.75rem;
  }

  #button-request-access {
    font-size:0.9rem;
  }

  .smaller-account-info {
    font-size: 0.9rem;
  }

</style>
